module.exports = __webpack_public_path__ + "img/timesheet-compressed.57f17eea.png";